import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as assessment from '../assessment'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: assessment.RESOURCE.payload.dimension.partialId,
      partialId: assessment.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Todo',
    isOptional: true,
    name: 'Current Revenue',
    partialId: PartialId.Standard.create('current_revenue'),
    type: core.common.value.types.Intrinsic.Currency,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
